import { createClient } from "@supabase/supabase-js";

export const supabase = createClient(
  "https://kjwavlaqjizgdhlhkgki.supabase.co",
  "sb_publishable_T3JIbzJ79bKQYqxVYY640g_8hrRqPzr"
);
